import {decamelizeKeys} from 'humps';
import {portfolioUrl} from 'shared/portfolio/utils';
import req, {rejectCamelizedErrors, rejectGenericError} from 'shared/req';
import {objectId} from 'shared/utils';
import {RECEIVE_INSTITUTION} from 'portfolio/actions/institution';

export const DELETE_ACTIVITY = 'DELETE_ACTIVITY';
export const EDIT_ACTIVITY = 'EDIT_ACTIVITY';
export const SCROLLED_TO_ACTIVITY = 'SCROLLED_TO_ACTIVITY';
export const RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY';
export const NEW_ACTIVITY = 'NEW_ACTIVITY';
export const CANCEL_EDIT_ACTIVITY = 'CANCEL_EDIT_ACTIVITY';
export const RECEIVE_ACTIVITIES = 'RECEIVE_ACTIVITIES';

export function deleteActivity(activity) {
  return (dispatch, getState) => {
    const {
      student: {_id},
    } = getState();
    return req({
      url: portfolioUrl(`/activities/${activity._id}`, _id),
      data: {activity_type: activity.activityType},
      method: 'DELETE',
    }).then(() =>
      dispatch({
        type: DELETE_ACTIVITY,
        id: activity._id,
      })
    );
  };
}

export function receiveActivity(activity) {
  return {
    type: RECEIVE_ACTIVITY,
    activity,
  };
}

export function cancelActivity(activity) {
  return {
    type: CANCEL_EDIT_ACTIVITY,
    activity,
  };
}

export function scrolledToActivity(id) {
  return {
    type: SCROLLED_TO_ACTIVITY,
    id,
  };
}

export function editActivity(activity) {
  return {
    type: EDIT_ACTIVITY,
    activity,
  };
}

export const saveActivity =
  (activity, scrollToActivity = true) =>
  (dispatch, getState) => {
    const {
      student: {_id},
    } = getState();
    let url = portfolioUrl('/activities', _id);
    let method;

    if (activity.new) {
      method = 'POST';
    } else {
      url = `${url}/${activity._id}`;
      method = 'PATCH';
    }

    return req({
      url: url,
      method: method,
      data: {activity: decamelizeKeys(activity)},
    })
      .then((receivedActivity) => {
        if (receivedActivity.institution) {
          dispatch({
            type: RECEIVE_INSTITUTION,
            institution: receivedActivity.institution,
          });
        }

        dispatch({
          type: RECEIVE_ACTIVITY,
          activity: {
            ...receivedActivity,
            scrollTo: scrollToActivity,
          },
        });
      })
      .catch(rejectCamelizedErrors)
      .catch(rejectGenericError);
  };

export function newActivity() {
  const activity = newActivityObject();

  return {
    type: NEW_ACTIVITY,
    activity: {
      ...activity,
      scrollTo: true,
    },
  };
}

export const newActivityObject = () => ({
  _id: objectId(),
  activityType: null,
  description: '',
  where: 'school',
  leadershipPositions: [],
  name: '',
  category: '',
  organization: null,
  participation: null,
  schoolYears: [],
  referrals: [''],
  createdAt: Math.floor(Date.now() / 1000),
  institution: {parentId: '', name: '', type: ''},

  // FE only
  editing: true,
  new: true,
});
